// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".f-80{font-size:80px}.lighter{font-family:'Proxima Nova Lt';font-weight:300}.semibold{font-family:'Proxima Nova Lt';font-weight:600}.bold{font-family:'Proxima Nova Rg';font-weight:bold}.black{font-family:'Proxima Nova Bl';font-weight:900}.regular{font-family:'Proxima Nova Rg';font-weight:normal}.segmentAccordainCards{margin-bottom:16px}\n", ""]);
// Exports
module.exports = exports;
